import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d5296b60&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d5296b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5296b60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5296b60')) {
      api.createRecord('d5296b60', component.options)
    } else {
      api.reload('d5296b60', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d5296b60&scoped=true&", function () {
      api.rerender('d5296b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s02Cl9xpJo5s/JS/comp/DocBox.vue"
export default component.exports